import { render, staticRenderFns } from "./SensorThreshold.html?vue&type=template&id=3619d916&scoped=true&external"
import script from "./SensorThreshold.vue?vue&type=script&lang=js"
export * from "./SensorThreshold.vue?vue&type=script&lang=js"
import style0 from "./SensorThreshold.scss?vue&type=style&index=0&id=3619d916&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3619d916",
  null
  
)

export default component.exports